// extracted by mini-css-extract-plugin
export default {"stripeLayout":"credit-card-form_stripeLayout__70811"};